<app-dashboard-header></app-dashboard-header>

<div class="resourcetypes-content">
  <h1 class="page-title">Resource Types</h1>
  
  <mat-card>
    <div class="card-header">
      <h2>Manage Resource Types</h2>
      <button mat-flat-button class="action-button accent" (click)="openAddDialog()">
        <mat-icon>add</mat-icon>
        Add Resource Type
      </button>
    </div>

      <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="40"></mat-progress-spinner>

      <div *ngIf="error" class="error-message">
        {{ error }}
      </div>

      <div *ngIf="!loading && resourceTypes.length > 0" class="table-container">
        <table mat-table [dataSource]="resourceTypes" style="width: 100%;">

          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let type">{{ type.id }}</td>
          </ng-container>

          <!-- Icon Column -->
          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef class="icon-header-cell">Icon</th>
            <td mat-cell *matCellDef="let type">
              <span
                *ngIf="type.icon"
                class="icon-table-cell"
              >
                <mat-icon class="icon-table-icon">{{ type.icon }}</mat-icon>
              </span>
              <span *ngIf="!type.icon" class="icon-table-cell" style="color: #bbb;">—</span>
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let type">
              <span style="display: inline-flex; align-items: center;">
                {{ type.name }}
                <mat-icon
                  class="info-icon"
                  [matTooltip]="'Slug: ' + type.slug"
                  matTooltipPosition="right"
                  style="font-size: 14px; margin-left: 4px; margin-top: 8px; color: #888; cursor: help;">
                  info
                </mat-icon>
              </span>
            </td>
          </ng-container>

          <!-- Max Concurrent Column -->
          <ng-container matColumnDef="maxConcurrent">
            <th mat-header-cell *matHeaderCellDef>Max Concurrent</th>
            <td mat-cell *matCellDef="let type">
              <span *ngIf="!type.allowMultiple">1</span>
              <span *ngIf="type.allowMultiple && type.maxConcurrent">{{ type.maxConcurrent }}</span>
              <span *ngIf="type.allowMultiple && !type.maxConcurrent"><em>Unlimited</em></span>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 280px;">Actions</th>
            <td mat-cell *matCellDef="let type">
              <button mat-icon-button color="primary" matTooltip="Edit" (click)="openEditDialog(type); $event.stopPropagation()">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="accent" matTooltip="Attributes" (click)="navigateToAttributes(type)">
                <mat-icon>list_alt</mat-icon>
              </button>
              <button mat-icon-button color="accent" matTooltip="Copy" (click)="copyResourceType(type); $event.stopPropagation()">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button mat-icon-button color="warn" matTooltip="Delete" (click)="deleteResourceType(type); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              class="clickable-row"
              (click)="openEditDialog(row)"
          ></tr>
        </table>
      </div>
      <div *ngIf="!loading && resourceTypes.length === 0" class="no-types">
        <mat-icon>info</mat-icon>
        <p>No resource types found. Click the "Add Resource Type" button to create your first resource type.</p>
      </div>
  </mat-card>
</div>

<app-dashboard-footer></app-dashboard-footer>
